//合同模板
import {contractApi} from "@/axios";
//获取合同模板信息
export function getTemplatePage(params,sendData){
    return contractApi({
        url:'/contract-template/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//下载模板
export function downloadTemplate(hexCode){
    return contractApi({
        url:'/contract-template/download/'+hexCode,
        method:'get',
        responseType: 'blob', // 设置响应类型为 blob
    })
}
//合同模板生成
export function templateGeneration(data){
    return contractApi({
        url:'/contract-template/template-generation',
        method:'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    })
}